export default "__VITE_ASSET__CyRdihtG__"